import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  Backdrop,
  Dialog,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Header from "components/Header";
import { Helmet } from "react-helmet";
import Unsubscribe from "pages/Unsubscribe";
import WelcomeContent from "pages/home/WelcomeContent";
import RoutingConfig from "RoutingConfig";
import { homeActions } from "actions";
import { homeService } from "services";
import ShareApp from "pages/home/ShareApp";
import AppRating from "pages/home/AppRating";
import RequireAuth from "./RequireAuth";
import ThemeConfig from "./Theme";
import ErrorComponent from "components/ErrorComponent";

const MainComponent = (props) => {
  const theme = useTheme();
  const { organizationInfo, authData, contentInfo, axiosErrorResponse } = props;
  const [locLoading, setLocLoading] = useState(false);
  const [locationFlag, setLocationFlag] = useState(false);
  const [jwtToken, setjwtToken] = useState("");
  const unsubscribeRoute =
    window.location.pathname === "/communication-preferences";

  const [value, setValue] = useState(5);
  const [unsubscribePage] = useState(unsubscribeRoute);
  const [loadWelcomePage, setLoadWelcomePage] = useState(true);
  const resultSuffix = "CVD";
  const [themeJS, setThemeJS] = useState(createTheme(ThemeConfig()));

  const [routes, setRoutes] = useState([]);
  const [widgetEnabled, setWidgetEnabled] = useState("N");

  const dispatch = useDispatch();
   const isHCPTemplate =
     organizationInfo?.type?.toLowerCase() === "h" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
   const setLocationData = () => {
     const localStoredZipData = JSON.parse(
       localStorage.getItem("storedZipData")
     );
     if (
       (authData?.device?.zipCode && authData?.device?.zipCode !== "null") ||
       localStoredZipData?.zipCode
     ) {
       let data = localStoredZipData || {};

       if (authData?.device?.zipCode && authData?.device?.zipCode !== "null") {
         data = {
           zipCode: authData?.device?.zipCode,
         };
       } else {
         dispatch(homeActions.saveZipCodeToServer(data?.zipCode));
       }

       dispatch(
         homeActions.saveCurrentLocationData({
           success: true,
           data,
         })
       );
     }
   };

   const getLocation = async () => {
     const currentLiveLocation1 = JSON.parse(
       localStorage.getItem("current_live_location1")
     );

     return new Promise((resolve, reject) => {
       if (navigator.geolocation) {
         navigator.permissions.query({ name: "geolocation" }).then((result) => {
           if (result.state === "prompt" || result.state === "denied") {
             setLocationData();
           }

           if (result.state === "prompt" || result.state === "granted") {
             if (result.state === "granted") {
               console.log(result);
               if (!currentLiveLocation1) {
                 setLocLoading(true);
               }
             }
             navigator.geolocation.getCurrentPosition(
               (pos) => {
                 if (!currentLiveLocation1) {
                   setLocLoading(true);
                 }
                 const google = (window.google = window.google
                   ? window.google
                   : {});
                 const point = new google.maps.LatLng(
                   pos.coords.latitude,
                   pos.coords.longitude
                   // 36.888443,
                   // -119.987346
                   // 37.149878,
                   // -120.2729
                   // 36.775277,
                   // -119.867011
                   // 33.173751,
                   // -96.757442
                 );
                 new google.maps.Geocoder()
                   .geocode({ latLng: point })
                   .then((res) => {
                     let locationData = {
                       zipcode: null,
                       zipCode: null,
                       sublocality: null,
                       locality: null,
                       city: null,
                       stateName: null,
                       administrative_area: null,
                       latitude: pos.coords.latitude,
                       longitude: pos.coords.longitude,
                       // latitude: 33.173751,
                       // longitude: -96.757442,
                     };
                     res.results[0].address_components.filter((subItem) => {
                       if (subItem?.types.indexOf("postal_code") !== -1) {
                         locationData.zipcode = subItem.long_name;
                         locationData.zipCode = subItem.long_name;
                       }
                       if (
                         subItem?.types.indexOf("sublocality_level_1") !== -1
                       ) {
                         locationData.sublocality = subItem.long_name;
                       }
                       if (subItem?.types.indexOf("locality") !== -1) {
                         locationData.locality = subItem.long_name;
                         locationData.city = subItem.long_name;
                       }
                       if (
                         subItem?.types.indexOf(
                           "administrative_area_level_1"
                         ) !== -1
                       ) {
                         locationData.administrative_area = subItem.short_name;
                         locationData.stateName = subItem.long_name;
                       }
                     });
                     resolve(locationData);
                   })
                   .catch((e) => {
                     reject(e);
                     setLocLoading(false);
                   });
                 setTimeout(() => {
                   setLocLoading(false);
                 }, 5000);
               },
               () => {
                 localStorage.setItem("zip_location_type", "manual");
               },
               { timeout: 5000 }
             );
           }
         });
       }
     });
   };
   const getcurrentLocation = async () => {
     try {
       let currentLocation = await getLocation();
       const currentLiveLocation1 = JSON.parse(
         localStorage.getItem("current_live_location1")
       );
       const currentLiveLocation2 = currentLocation;
       localStorage.setItem(
         "current_live_location2",
         JSON.stringify(currentLocation)
       );

       if (
         !currentLiveLocation1 ||
         (currentLiveLocation1 &&
           currentLiveLocation2 &&
           currentLiveLocation1.zipcode === currentLiveLocation2.zipcode)
       ) {
         if (!currentLiveLocation1) {
           localStorage.setItem(
             "current_live_location1",
             JSON.stringify(currentLocation)
           );
         }
         try {
           const zipcodeData = await homeService.getCityStateForZipCode(
             currentLocation?.zipCode
           );
           if (zipcodeData?.success && zipcodeData?.data) {
             dispatch(homeActions.savedevicelocation(currentLocation));
             dispatch(homeActions.setCurrentLocation(currentLocation));
           } else {
             dispatch(homeActions.getCityStateForZipCodeError(zipcodeData));
           }
         } catch (e) {
           dispatch(homeActions.getCityStateForZipCodeError(e));
           const localStoredZipData = JSON.parse(
             localStorage.getItem("storedZipData")
           );
           if (localStoredZipData?.zipCode) {
             dispatch(
               homeActions.saveCurrentLocationData({
                 success: true,
                 localStoredZipData,
               })
             );
           }
           console.log(e);
         }
       }

       setLocLoading(false);
     } catch (e) {
       const localStoredZipData = JSON.parse(
         localStorage.getItem("storedZipData")
       );
       if (localStoredZipData?.zipCode) {
         dispatch(
           homeActions.saveCurrentLocationData({
             success: true,
             localStoredZipData,
           })
         );
       }
       setLocLoading(false);
       console.log(e);
     }
   };

   const setInsuranceFlag = () => {
     if (authData?.device?.insuranceId) {
       let obj = {
         id: authData?.device?.insuranceId,
         name: authData?.device?.insuranceName,
         type: authData?.device?.insuranceType,
         formularyText: authData?.device?.insuranceName,
       };

       dispatch(homeActions.saveInsuranceData(obj));
     } else {
       let insData = contentInfo?.INSURANCE_HELP_V2?.contentParam?.filter(
         (item) => item.value.type === "W"
       )[0];
       if (organizationInfo?.organizationOptionJson?.defaultInsuranceId) {
         insData = contentInfo?.INSURANCE_HELP_V2?.contentParam?.filter(
           (item) =>
             item.value.id ===
             organizationInfo?.organizationOptionJson?.defaultInsuranceId
         )[0];
       }
       dispatch(
         homeActions.saveInsuranceData({
           ...insData?.value,
           name: insData?.displayText,
         })
       );
     }
   };

   useEffect(() => {
     if (
       contentInfo &&
       contentInfo.INSURANCE_HELP_V2 &&
       contentInfo.INSURANCE_HELP_V2.content
     ) {
       setInsuranceFlag();
     }
   }, [contentInfo]);
   const setDisplayMode = () => {
     let search = window.location.search;
     let params = new URLSearchParams(search);
     let displayMode = params.get("displayMode");
     let ref = params.get("ref");
     let flag = "N";

     if (
       displayMode &&
       displayMode?.toLowerCase() === "widget" &&
       organizationInfo?.organizationOptionJson?.widgetEnabled?.toLowerCase() ===
         "y"
     ) {
       flag = "Y";
     }
     setWidgetEnabled(flag);
     sessionStorage.setItem("widgetEnabled", flag);
     if (ref) {
       sessionStorage.setItem("ref", ref);
     }
     console.log("setDisplayMode", flag);
     console.log("ref", ref);
   };

   useEffect(() => {
     setDisplayMode();
   }, [organizationInfo]);

   useEffect(() => {
     if (authData !== null && authData?.organization) {
       if (
         authData?.organization?.organizationOptionJson?.locationPrivacyFlag?.toLowerCase() ===
         "y"
       ) {
         setLocationFlag(true);
       } else {
         setLocationData();
       }
     }
     if (authData?.jwtToken) {
       setjwtToken(authData?.jwtToken);
       if (!contentInfo?.INSURANCE_HELP_V2) {
         dispatch(homeActions.getContentType("INSURANCE_HELP_V2"));
       }

       const themeObj = ThemeConfig();
       setThemeJS(createTheme(themeObj));
       let routes = RoutingConfig[resultSuffix];

       if (
         authData?.organization?.organizationOptionJson?.signInOutFlag?.toLowerCase() ===
         "y"
       ) {
         routes = [...routes, ...RoutingConfig["SIGN_IN"]];
       }

       if (!isHCPTemplate) {
         routes = [...routes, ...RoutingConfig["SAVINGS"]];
       }

       setRoutes(routes);
     }
   }, [authData]);

  useEffect(() => {
    if (locationFlag) {
      getcurrentLocation();
    }
  }, [locationFlag]);

  return (
    <ThemeProvider theme={themeJS}>
      <>
        {locLoading && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (themeIndex) => themeIndex.zIndex.drawer + 1,
            }}
            open={locLoading}
          >
            <Dialog fullWidth={true} maxWidth={"sm"} open={locLoading}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "80px",
                }}
              >
                <CircularProgress
                  style={{ color: theme?.palette?.secondary?.main }}
                />
                <Typography
                  sx={{ paddingLeft: "10px" }}
                  variant="h3LatoRegular"
                >
                  Fetching current location
                </Typography>
              </div>
            </Dialog>
          </Backdrop>
        )}
        <div className="app-container" id="appcontent">
          {unsubscribePage ? (
            <Unsubscribe />
          ) : loadWelcomePage ? (
            <WelcomeContent
              onSaveClick={(prodCode) => setLoadWelcomePage(prodCode)}
            />
          ) : (
            <div style={{ paddingTop: "1px" }}>
              <div
                style={{
                  display:
                    widgetEnabled?.toLowerCase() === "y" ? "none" : undefined,
                }}
              >
                {RoutingConfig[resultSuffix] && (
                  <Header
                    value={value}
                    setValue={setValue}
                    showWelcomeScreen={() => setLoadWelcomePage(true)}
                    stylingClass={organizationInfo?.suffix}
                  />
                )}
              </div>
              <Helmet>
                <title>{organizationInfo?.websiteTitle}</title>
                <meta
                  name="Cuverd Description"
                  content="Ths is Cuverd related to main file."
                />
                <meta property="og:title" content="Landing Page" />
              </Helmet>
              {jwtToken ? (
                <div>
                  <Switch>
                    {routes.map((route) => (
                      <Route
                        key={route.path}
                        exact={route.exact}
                        path={route.path}
                        render={(wrapperProps) =>
                          route.isSecure ? (
                            <RequireAuth
                              Component={route.component}
                              {...wrapperProps}
                              setValue={setValue}
                            />
                          ) : (
                            <route.component
                              {...wrapperProps}
                              setValue={setValue}
                            />
                          )
                        }
                      />
                    ))}
                    <Redirect from="*" to="/" />
                  </Switch>
                  <ShareApp />
                  <AppRating />

                  {axiosErrorResponse?.message &&
                    axiosErrorResponse?.success === false && (
                      <ErrorComponent axiosErrorResponse={axiosErrorResponse} />
                    )}
                </div>
              ) : null}
            </div>
          )}
        </div>
      </>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    authData: state.authentication.authData,
    contentInfo: state.contentType.data,
    // organizationInfo: { suffix: "WGN" },
  };
};

export default connect(mapStateToProps)(MainComponent);